export default "__VITE_ASSET__CiVOS1eU__"